import AdFormWizard, { type AdFormData } from "@/components/user/AdFormWizard";
import { useProfile } from "@/hooks";
import { PriceType } from "@/interfaces/exchange";
import { queryClient } from "@/services/queryClient";
import { useAppSelector } from "@/store/hooks";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { makeRequest } from "@/utils/makeRequest";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";

export default function AdFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = !!id;
  const { user } = useAppSelector((state) => state.auth);
  const userId = user?.id || "";

  const { data: profile } = useProfile(userId);

  console.log("PROFILE", profile);

  const handleSubmit = async (data: AdFormData) => {
    try {
      const payload = {
        ...data,
        price: data.priceType === PriceType.FIXED ? data.price : undefined,
        floatingMargin:
          data.priceType === PriceType.FLOATING
            ? data.floatingMargin
            : undefined,
        minAmount: String(data.minAmount),
        maxAmount: String(data.maxAmount),
        totalAmount: String(data.totalAmount),
        terms: data.terms.map((t, i) => ({
          title: t.title?.trim() || null,
          description: t.description.trim(),
          order: t.order ?? i,
          isActive: true,
        })),
      };

      if (isEditing) {
        await makeRequest.put(`/advertisement/${id}`, payload);
        toast.success("Ad updated successfully");
      } else {
        await makeRequest.post("/advertisement", payload);
        toast.success("Advertisement published successfully");
      }

      queryClient.invalidateQueries({ queryKey: ["profile", userId] });
      queryClient.invalidateQueries({ queryKey: ["wallet", userId] });
      navigate("/dashboard/p2p");
    } catch (error: any) {
      toast.error(getErrorMessage(error) || "Failed to create ad");
      console.log(error);
    }
  };

  return (
    <div className="min-h-screen lg:p-10">
      <AdFormWizard
        isEditing={isEditing}
        availablePaymentMethods={profile?.paymentMethods || []}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
